import React, { useContext, useState, useMemo, useEffect } from "react"
import { UserContext } from "../../../context/userContext"
import trcss from "../../../styles/Telerecovery.module.css"

// Comps
import ChatComponent from "./ChatComponent"

export default function TRSMSIndex({ isOkayToText, staffPhoneNumber, selectedConv, onNewMessage }) {
  const userCtx = useContext(UserContext)
  const [participant, setParticipant] = useState(selectedConv?.participant)

  const participantName = useMemo(() => {
    if (!userCtx.participant_name_first || !userCtx.participant_name_last)
      return ""
    return `${userCtx.participant_name_first} ${userCtx.participant_name_last}`
  }, [userCtx.participant_name_first, userCtx.participant_name_last])

  const participantInitials = useMemo(() => {
    if (!userCtx.participant_name_first || !userCtx.participant_name_last)
      return ""
    return userCtx.participant_name_first.charAt(0).toUpperCase() + userCtx.participant_name_last.charAt(0).toUpperCase()
  }, [userCtx.participant_name_first, userCtx.participant_name_last])

  useEffect(() => {
    if (selectedConv) {
      setParticipant(selectedConv?.participant)
    } else {
      setParticipant({ id: userCtx.participant_id, phone: userCtx.participant_phone_primary, name: participantName, initials: participantInitials })
    }
  }, [selectedConv])

  if (participant && !participant.phone) {
    return (
      <span style={{ fontSize: "20px" }}>
        The participant does not have a primary phone number, which is
        required for the SMS feature.
      </span>
    )
  }

  if (participant) {
    return (
      <div className={trcss.chatWrapper}>
        <ChatComponent staffPhoneNumber={staffPhoneNumber} participant={participant} onNewMessage={onNewMessage} isOkayToText={isOkayToText} />
      </div>
    )
  }

  return null
}